<template>
  <div class="mass-patient-list">
    <div v-if="patients.length === 0" class="text-muted text-center py-1 font-small-3">
      Belum ada pasien ditambahkan. Cari dan pilih pasien di atas.
    </div>
    <b-table-simple v-else small bordered responsive class="mb-0">
      <b-thead>
        <b-tr>
          <b-th style="width: 40px;" class="text-center">#</b-th>
          <b-th style="width: 90px;">No.RM</b-th>
          <b-th>Nama Pasien</b-th>
          <b-th v-if="showNomorPolis" style="width: 160px;">No. Polis</b-th>
          <b-th style="width: 100px;" class="text-center">Status</b-th>
          <b-th style="width: 50px;" class="text-center">Aksi</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(entry, index) in patients" :key="index">
          <b-td class="text-center">{{ index + 1 }}</b-td>
          <b-td>
            <code class="font-small-3">{{ entry.pasien.norm }}</code>
          </b-td>
          <b-td>{{ entry.pasien.nama }}</b-td>
          <b-td v-if="showNomorPolis">
            <b-form-input
              v-if="entry.status === 'pending'"
              :value="entry.nomor_polis"
              size="sm"
              placeholder="No. Polis"
              :disabled="disabled"
              class="font-small-3"
              @input="$emit('update-polis', { index, value: $event })"
            />
            <span v-else class="font-small-3">{{ entry.nomor_polis || '-' }}</span>
          </b-td>
          <b-td class="text-center">
            <b-badge v-if="entry.status === 'pending'" variant="light-secondary" pill>
              Menunggu
            </b-badge>
            <b-badge v-else-if="entry.status === 'processing'" variant="light-warning" pill>
              <b-spinner small type="grow" class="mr-25" />
              Mendaftar...
            </b-badge>
            <b-badge v-else-if="entry.status === 'success'" variant="light-success" pill>
              <feather-icon icon="CheckIcon" size="12" class="mr-25" />
              Berhasil
            </b-badge>
            <span v-else-if="entry.status === 'failed'">
              <b-badge
                v-b-tooltip.hover.bottom="entry.error"
                variant="light-danger"
                pill
                class="cursor-pointer"
              >
                <feather-icon icon="XIcon" size="12" class="mr-25" />
                Gagal
              </b-badge>
            </span>
          </b-td>
          <b-td class="text-center">
            <b-button
              v-if="entry.status === 'pending' && !disabled"
              variant="flat-danger"
              size="sm"
              class="btn-icon p-25"
              @click="$emit('remove', index)"
            >
              <feather-icon icon="TrashIcon" size="14" />
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'MassPatientList',
  props: {
    patients: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showNomorPolis: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'update-polis'],
}
</script>

<style lang="scss" scoped>
.mass-patient-list {
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  max-height: 250px;
  overflow-y: auto;

  .table {
    margin-bottom: 0;

    th {
      font-size: 0.75rem;
      font-weight: 600;
      color: #495057;
      padding: 0.35rem 0.5rem;
      background: #f8f9fa;
      white-space: nowrap;
    }

    td {
      font-size: 0.8rem;
      padding: 0.25rem 0.5rem;
      vertical-align: middle;
    }
  }
}
</style>
